export default __webpack_public_path__ + "static/media/jumpLand.114db86b.mp3";